import { gql } from '@apollo/client';

export const GET_ALL_ASSETS = gql`
  query GetAllAssets(
    $page: Int
    $pageSize: Int
    $purchaseDateFrom: String
    $purchaseDateTo: String
    $productName: String
    $warrantyDuration: Int
    $description: String
    $assetTagId: String
    $brand: String
    $model: String
    $category: String
    $department: String
    $purchasedFrom: String
    $cost: String
    $createdBy: String
    $checkedOutBy: String
    $expectedCheckInDate: String
    $maintenanceCost: String
    $checkOutDate: String
  ) {
    getAllAssets(
      page: $page
      pageSize: $pageSize
      productName: $productName
      warrantyDuration: $warrantyDuration
      purchaseDateFrom: $purchaseDateFrom
      purchaseDateTo: $purchaseDateTo
      description: $description
      assetTagId: $assetTagId
      brand: $brand
      model: $model
      category: $category
      department: $department
      purchasedFrom: $purchasedFrom
      cost: $cost
      createdBy: $createdBy
      checkedOutBy:$checkedOutBy
      expectedCheckInDate:$expectedCheckInDate
      maintenanceCost: $maintenanceCost
      checkOutDate: $checkOutDate
    ) {
      records {
        id
        description
        assetTagId
        productName
        warrantyDuration
        purchasedFrom
        purchaseDate
        cost
        brand
        model
        category
        department
        assetPhoto
        createdBy
        status
        checkInStatus
        checkedOutBy
        checkOutReason
        expectedCheckInDate
        checkOutDate
        maintenanceCost
        billPhoto {
          originalName
          mimeType
          url
        }
        isManuallyAddedToMaintenance
        updateHistory {
          editedBy
          editedAt
          changes {
            field
            oldValue
            newValue
          }
        }
        maintenanceHistory {
          editedBy
          editedAt 
          productName
          description
          maintenanceCost
          billPhoto {
            originalName
            mimeType
            url
          }
          changes {
            field
            oldValue
            newValue
          }
        }
        attachments {
          id
          filename
          data
          userId
          emailId
          mimetype
          addDate
          updateDate
          status
          userName
          attachmetHistory{
            userId
            emailId
            userName
            replacedFile
            data
            filename
            mimetype
            deleteDate
            addDate
            updateDate
            status
          }
        } 
      
        warrantyAttachments {
        id
        filename
        data
        userId
        emailId
        mimetype
        addDate
        updateDate
        status
        userName
        attachmetHistory{
        userId
       emailId
       userName
        replacedFile
       data
      filename
    mimetype
     deleteDate
    addDate
    updateDate
    status
        }
      }
       
      }
      totalCount
    }
  }
`;

export const GET_ASSET_ATTACHMENTS = gql`
  query {
    getAllAttachmentsOnly {
      assetTagId
      attachments {
        userId
        emailId
        filename
        data
        mimetype
        status
      }
        status
    }
  }
`;

export const ADD_ASSET = gql`
  mutation AddAsset(
    $description: String
    $productName: String
    $warrantyDuration: Int  
    $purchasedFrom: String
    $assetTagId: String
    $purchaseDate: String
    $cost: Float
    $brand: String
    $model: String
    $category: String
    $department: String
    $assetPhoto: String
    $createdBy: String
    $attachments: [AttachemntsInputType]
    $warrantyAttachments: [AttachemntsInputType]
  ) {
    addAsset(
      description: $description
      productName: $productName
      warrantyDuration: $warrantyDuration
      purchasedFrom: $purchasedFrom
      assetTagId: $assetTagId
      purchaseDate: $purchaseDate
      cost: $cost
      brand: $brand
      model: $model
      category: $category
      department: $department
      assetPhoto: $assetPhoto
      createdBy: $createdBy
      input: $attachments
      warrantyAttachments: $warrantyAttachments
    ) {
      id
      assetTagId
      description
      productName
      warrantyDuration
      purchasedFrom
      purchaseDate
      cost
      brand
      model
      category
      department
      assetPhoto
      createdBy
      createdAt
      status
      checkInStatus
      checkedOutBy
      checkOutReason
      expectedCheckInDate
      checkOutDate
      maintenanceCost
      attachments {
        id
        filename
        mimetype
        data  
        status
        updateDate
        deleteDate
        userId
        emailId
        userName
        addDate
      }
      warrantyAttachments {
       id
        filename
        mimetype
        data  
        status
        updateDate
        deleteDate
        userId
        emailId
        userName
        addDate
      }
    }
  }
`;

export const UPDATE_ASSET = gql`
  mutation UpdateAsset(
    $id: ID!
    $description: String
    $warrantyDuration: Int
    $productName: String
    $purchasedFrom: String
    $assetTagId: String
    $purchaseDate: String
    $cost: Float
    $brand: String
    $model: String
    $category: String
    $department: String
    $assetPhoto: String
    $createdBy: String
    $editedBy: String
    $editedAt: String
    $maintenanceCost: Float
    $billPhoto: [BillPhotoInput]
    $attachments: [AttachemntsInputType]
    $warrantyAttachments: [AttachemntsInputType]
  ) {
    updateAsset(
      id: $id
      description: $description
      warrantyDuration: $warrantyDuration
      productName: $productName
      purchasedFrom: $purchasedFrom
      assetTagId: $assetTagId
      purchaseDate: $purchaseDate
      cost: $cost
      brand: $brand
      model: $model
      category: $category
      department: $department
      assetPhoto: $assetPhoto
      createdBy: $createdBy
      editedBy: $editedBy
      editedAt: $editedAt
      maintenanceCost: $maintenanceCost
      billPhoto: $billPhoto
      input: $attachments
      warrantyAttachments: $warrantyAttachments
    ) {
      id
      description
      purchasedFrom
      assetTagId
      productName
      warrantyDuration
      purchaseDate
      cost
      brand
      model
      category
      department
      assetPhoto
      createdBy
      createdAt
      status
      checkInStatus
      checkedOutBy
      checkOutReason
      expectedCheckInDate
      checkOutDate
      updateHistory {
        editedBy
        editedAt
        changes {
          field
          oldValue
          newValue
        }
      }
      maintenanceHistory {
        editedBy
        editedAt 
        productName
        description
        maintenanceCost
        billPhoto {
          originalName
          mimeType
          url
        }
        changes {
          field
          oldValue
          newValue
        }
      }
      attachments {
        id
        filename
        mimetype
        data  
        status
        updateDate
        deleteDate
        userId
        emailId
        userName
        addDate
        attachmetHistory {
          userId
          emailId
          filename
          userName
          replacedFile
          mimetype
          addDate
          updateDate
          data
          status
          deleteDate
        }
      }
      warrantyAttachments {       
        filename
        mimetype
        data
        status
        updateDate
        deleteDate
        userId
        emailId
        userName
        addDate
        attachmetHistory {
          userId
          emailId
          filename
          userName
          mimetype
          addDate
          updateDate
          data
          status
          deleteDate
        }
      }
    }
  }
`;

export const REMOVE_ATTACHMENT_Asset = gql`
  mutation removeAttachmentFince($id: String!, $userId: String! ,$input:AttachemntsInputType! ) {
    removeAttachmentFince(id: $id, attachmentId: $userId ,input:$input ) {
       status
       message
}
  }
`;
export const SOFT_DELETE_ASSET_RECORD = gql`
  mutation softDeleteAssetRecord($id: ID!, $userName: String!, $editedAt: String!) {
    softDeleteAssetRecord(id: $id, userName: $userName, editedAt: $editedAt) {
      id
      status
    }
  }
`;

export const CHECKOUT_ASSET = gql`
  mutation CheckOutAsset(
    $id: ID!
    $checkedOutBy: String
    $checkOutReason: String
    $expectedCheckInDate: String
    $checkOutDate: String
    $suppressCheckInStatus: Boolean
    $isManuallyAddedToMaintenance: Boolean
  ) {
    checkOutAsset(
      id: $id
      checkedOutBy: $checkedOutBy
      checkOutReason: $checkOutReason
      expectedCheckInDate: $expectedCheckInDate
      checkOutDate: $checkOutDate
      suppressCheckInStatus: $suppressCheckInStatus
      isManuallyAddedToMaintenance: $isManuallyAddedToMaintenance
    ) {
      id
      checkInStatus
      checkedOutBy
      checkOutReason
      expectedCheckInDate
      checkOutDate
      isManuallyAddedToMaintenance   
    }
  }
`;


export const CHECKIN_ASSET = gql`
  mutation CheckInAsset($id: ID!) {
    checkInAsset(id: $id) {
      id
      checkInStatus
    }
  }
`;


